import React from 'react';
import moment from 'moment';
import { Card, Table } from 'react-bootstrap';

const GridValidadores = ({ validadores, loading, cotacaoSelecionada }) => {
  const lista = Array.isArray(validadores) ? validadores : [];

  return (
    <Card className="shadow-sm">
      <Card.Header
        className="py-2"
        style={{ backgroundColor: '#0747a6', color: '#fff' }}
      >
        <strong>Validadores</strong>
      </Card.Header>
      <Card.Body className="p-0">
        {!cotacaoSelecionada ? (
          <p className="text-muted text-center my-4">
            Selecione uma cotação para consultar os validadores.
          </p>
        ) : loading ? (
          <p className="text-muted text-center my-4">Carregando validadores...</p>
        ) : lista.length === 0 ? (
          <p className="text-muted text-center my-4">
            Nenhum validador encontrado para a cotação selecionada.
          </p>
        ) : (
          <div className="table-responsive">
            <Table striped bordered hover size="sm" className="mb-0">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th style={{ width: 180 }}>Data Conf.</th>
                </tr>
              </thead>
              <tbody>
                {lista.map((item) => (
                  <tr
                    key={`${item.nome_completo}-${item.data_conf || 'pendente'}`}
                  >
                    <td>{item.nome_completo}</td>
                    <td>
                      {item.data_conf
                        ? moment(item.data_conf).format('DD/MM/YYYY HH:mm')
                        : '-'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default GridValidadores;
